import { EventEmitter, Injectable,OnInit } from '@angular/core';
//import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
//import 'rxjs/Rx';
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/Rx';

import { Observable } from 'rxjs';

import { LoggingService } from '../logging.service';

export interface iShuttle {
     id: number;
     name: string;
     driver_id?: number;
     driver_name?: string;
     driver?:iDriver;
     delay?:number;
     status?:string;
     route?:iRoute;
     route_name?:string;
     atStop?:boolean;
     lastStop?:iZone;
     nextStop?:iZone;
     nextArrivalTime?:string;
     last_arrival_time?:any;
     route_calculated_stops?:iZone[];
     route_calculated?:any;
     times?:any;
     deviatingStop?:number;
     temp_stops?:any[];
}

export interface iZone{
     id:number;
     name: string;
     shape?: iPoint[];
     type?: string;
}
export interface iDriver{
     id:number;
     name: string;
}

export interface iRoute{
     id:number;
     name: string;
     zones?: iZone[]
}

export interface iPoint{
     lat: number;
     lng: number;
}

@Injectable()
export class shuttleService {

     //shuttle: iShuttle = {id:0};
     allShuttles: iShuttle[];
     allRoutes: iRoute[];
     allZones: iZone[];
     allRouteStops: iZone[];
     shuttleRoute: iRoute[];

     atStop: boolean = false;
     lastStop: iZone;
     nextStop: iZone;
     currentStop: iZone;

     allZoneTypes:string[];
     temp_stops:any[];

     //statusUpdated = new EventEmitter<string>();
     constructor(private loggingService: LoggingService, private http:Http) {
          console.log('shuttle service constructor');
          this.setAllShuttles();
          this.setAllRoutes();
          this.setAllZones();
          console.log('END shuttle service constructor');
     }

     setAllShuttles(){
          this.getAllShuttles().subscribe((response)=>{
               //console.log(response.json());
               console.log('building allShuttles');
               var data = response.json();

               let shuttles = [];
               for(let ts of data){
                    let t_shuttle : iShuttle = {} as any;
                    //console.log(ts);
                    t_shuttle.id = ts.id;
                    t_shuttle.name = ts.name;
                    t_shuttle.status = ts.status;
                    //t_shuttle.type = ts.type;
                    shuttles.push( t_shuttle);
                    /*
                    id: number;
                    name: string;
                    driver_id?: number;
                    delay?:number;
                    status?:string;
                    route?:iRoute;
                    atStop?:boolean;
                    lastStop?:iZone;
                    nextStop?:iZone;
                    nextArrivalTime?:string;

                    */
                    /*if(t_zone.type == 'Stop'){
                         stopZones.push( t_zone);
                    }*/
               }
               //console.log(shuttles);
               this.allShuttles = shuttles;
               console.log('Finally setting allShuttles');
               console.log(this.allShuttles);
               //console.log('allShuttles');
               //console.log(this.allShuttles);
               //this.allRouteStops = stopZones;
          });
     }


     setAllZones(){
          this.getAllStops().subscribe((response)=>{
               //console.log(response.json());
               var data = response.json();

               let zones = [];
               let stopZones = [];
               let allZonesTypes = [];
               for(let tz of data){
                    let t_zone : iZone = {} as any;
                    //console.log(tz);
                    t_zone.id = tz.id;
                    t_zone.name = tz.name;
                    t_zone.type = tz.type;
                    zones.push( t_zone);
                    if(t_zone.type == 'Stop'){
                         stopZones.push( t_zone);
                    }
                    allZonesTypes[tz.type] = tz.type;
               }
               //console.log(zones);
               this.allZones = zones;
               this.allRouteStops = stopZones;
               //this.allZoneTypes = allZonesTypes;
               console.log('all zones ++++++++++++++++++++++++++++++++++++++');
               console.log(this.allZones);


               this.allZoneTypes = ['Deactivate','Courtesy','Stop'];//Array.from(new Set(this.allZones.map(({type}) => type )));
               console.log('all zone types ++++++++++++++++++++++++++++++++++++++');
               console.log(this.allZoneTypes);

               //let fAllZones = [];



          });
     }
     setAllRoutes(){
          this.getAllRoutes().subscribe((response)=>{
               ///console.log(response.json());
               var data = response.json();
               let routes = [];
               for(let tr of data){
                    let t_route : iRoute = {} as any;
                    t_route.id = tr.id;
                    t_route.name = tr.name;
                    routes.push( t_route);
               }
               //console.log(routes);
               this.allRoutes = routes;

          });
     }

     getAllShuttles(is_available:boolean = true){
          console.log('getting all shuttles');
          var url_params = '';
          if(is_available ===false){
               url_params = '?all=true';
          }
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/get-all-shuttles.php' + url_params;
          return this.http.get(data_url)
     }

     getStopsOnRoute(id){
          console.log('getStopsOnRoute');
          let url_params = '?route_id=' + id;
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/get-route-stops.php' + url_params;
          let data = this.http.get(data_url).subscribe((response)=>{
               //console.log('getStopsOnRoute response ');
               //console.log(response.json());

               var rdata = response.json();
               let routes = [];
               //console.log(rdata);
               for(let tr of rdata){
                    //console.log('x');
                    let t_route : iRoute = {} as any;
                    t_route.id = tr.id;
                    t_route.name = tr.name;
                    routes.push( t_route);
               }

               //console.log(routes);
               this.temp_stops = routes;
          });
          //this.temp_stops = '';



     }
     getShuttleById(id:number){
          console.log('getting shuttle by id ' + id);
          var url_params = '';

          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/get-shuttle-by-id.php?id='+id;

          return this.http.get(data_url);

     }

     driver_login(driver,pin){
          console.log('login in driver');
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/driver-login.php?driver='+driver+'&pin='+pin;

          return this.http.get(data_url);



      //return {};
      //return false;
     }

     assignDriverToShuttle(shuttle_id,driver_id){
          console.log('assign d to s' + shuttle_id+' - ' +driver_id);
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/assing-driver-to-shuttle.php';
          var data = {shuttle_id:shuttle_id,driver_id:driver_id};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
          return this.http.post(data_url,data,{headers:headers}).map((response)=>{console.log('assignDriverToShuttle');console.log(response);return response;});
     }
     getAllRoutes(){
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/get-all-routes.php';
          return this.http.get(data_url);
     }
     getAllStops(){
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/get-all-stops.php';
          return this.http.get(data_url);
     }

     resetShuttle(shuttle_id){
          console.log('resetShuttle');
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/reset-shuttle.php';
          var data = {shuttle_id:shuttle_id};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
          return this.http.post(data_url,data,{headers:headers}).map((response)=>{console.log('ShuttleReset');console.log(response);return response;});

     }


     takeABreakShuttle(shuttle_id){

          console.log('takeABreakShuttle');
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/shuttle-take-break.php';
          var data = {shuttle_id:shuttle_id};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
          this.http.post(data_url,data,{headers:headers}).subscribe((response)=>{console.log('ShuttleBreak');console.log(response);return response;});


     }

     assignRouteToShuttle(shuttle_id,route_id,start_id,stop_id){
          console.log('assignRouteToShuttle');
          console.log(shuttle_id);console.log(route_id);console.log(start_id);console.log(stop_id);
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/assing-route-to-shuttle.php';
          var data = {shuttle_id:shuttle_id,route_id:route_id,start_id:start_id,stop_id:stop_id};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

          return this.http.post(data_url,data,{headers:headers}).map((response)=>{console.log('assignRouteToShuttle');data = response.json(); console.log(data);return response;});
          //console.log(data.results);
     }

     promise_assignRouteToShuttle(shuttle_id,route_id,start_id,stop_id){
          console.log('promise_assignRouteToShuttle');
          console.log(shuttle_id);console.log(route_id);console.log(start_id);console.log(stop_id);
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/assing-route-to-shuttle.php';
          var data = {shuttle_id:shuttle_id,route_id:route_id,start_id:start_id,stop_id:stop_id};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

          return this.http.post(data_url,data,{headers:headers}).map((response)=>{console.log('promise_assignRouteToShuttle');data = response.json(); console.log(data);return response;});
          //console.log(data.results);
     }

     reachedStop(shuttle_id,type){
          console.log('reachedStop');
          console.log('move');
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/shuttle-move.php';
          var data = {shuttle_id:shuttle_id,shuttle_action:'arriving',type:type};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
          return this.http.post(data_url,data,{headers:headers}).map((response)=>{
               console.log('reached');
               console.log(response.json());
               console.log('reachedStop - ShuttleAtStop');
               data = response.json();
               console.log(data);
               console.log(response);
               return response;
          });
     }

     leaveStop(shuttle_id,type){
          console.log('leaveStop');
          console.log('move');

          //var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/shuttle-leave-stop.php';
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/shuttle-move.php';
          var data = {shuttle_id:shuttle_id,shuttle_action:'leaving',type:type};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
          return this.http.post(data_url,data,{headers:headers}).map((response)=>{
               console.log('leave');
               //console.log(response.json());
               console.log('ShuttleleaveStop');
               data = response.json();
               console.log(data);
               console.log(response);
               return response;
          });
     }

     setDelay(shuttle_id,delay){
          console.log('setDelay');
          console.log(shuttle_id);
          console.log(delay);
          var data_url = 'http://shuttles.thedesigngrouponline.com/app-data/set-shuttle-delay.php';
          var data = {shuttle_id:shuttle_id,delay:delay};
          const headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
          return this.http.post(data_url,data,{headers:headers}).map((response)=>{console.log('setDelayinside');console.log(response);return response;});

     }
/*


     setShuttleById(id){

          var r = this.getShuttleById(id);
          console.log(r);



     }

*/
}
